import { render, staticRenderFns } from "./AddVideoSession.vue?vue&type=template&id=5f167d48"
import script from "./AddVideoSession.vue?vue&type=script&lang=js"
export * from "./AddVideoSession.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports